var theme = require('./theme')
var flatten = require('./flatten')

module.exports = theme('da_DK', flatten(require('./source/da_DK')))
